import { includes, map, get, filter, isEmpty, every } from 'lodash'

const filteredAssetTypes = (filters, assets) => filter(assets, (asset) => {
  const filterResults = {}

  if (filters.managedByCalligo != 'All') {
    filterResults['managedByCalligo'] = includes(map(filters.managedByCalligo, 'label'), get(asset, 'managed_by_calligo'))
  }

  if (filters.assetCategory != 'All') {
    filterResults['assetCategory'] = includes(map(filters.assetCategory, 'value'), get(asset, 'asset_category_id'))
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})

export { filteredAssetTypes }
